import { render, staticRenderFns } from "./PageProductRecall.vue?vue&type=template&id=4121bc02&scoped=true"
import script from "./PageProductRecall.vue?vue&type=script&lang=js"
export * from "./PageProductRecall.vue?vue&type=script&lang=js"
import style0 from "./PageProductRecall.vue?vue&type=style&index=0&id=4121bc02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4121bc02",
  null
  
)

export default component.exports